module.exports = __webpack_public_path__ + "static/media/silhouette6.bb8b490f.jpeg";